import { render } from "./TeamingHint.vue?vue&type=template&id=4848fda6&scoped=true"
import script from "./TeamingHint.vue?vue&type=script&lang=js"
export * from "./TeamingHint.vue?vue&type=script&lang=js"

import "./TeamingHint.vue?vue&type=style&index=0&id=4848fda6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4848fda6"

export default script